import React from 'react';

export const RightColumn = ({ children }: { children: React.ReactNode }) => {
    return <div id="rightcolumn">{children}</div>;
};
